const state = {
  projects: [],
  project: {
    id: 0,
    name: '',
    created_at: new Date(),
    updated_at: new Date(),
    description: '',
    responsible: {
      id: undefined,
      email: '',
      full_name: '',
      first_name: '',
      last_name: '',
      created_at: new Date(),
      updated_at: new Date(),
      labels: { data: []},
    },
    fnd: {
      id: undefined,
      name: '',
      code: '',
      description: '',
      created_at: new Date(),
      updated_at: new Date(),
    },
    attachments: undefined,
  },
  controlPoints: [],
  controlPointRequests: [],
  isControlPointOpened: false,
  controlPoint: undefined,
  isControlPointRequestOpened: false,
  controlPointRequest: {},
  isNotificationOpened: false,
  notification: {},
};

export default state;
